import React from 'react';
import { Box, Tooltip } from '@mui/material';
import * as subMatFolderActions from '../../store/subMatFolder';

const BADGE_COLOR = '#5C6B7A';

/** 채워진 배지는 실물 폴더, 테두리 배지는 붙여 둔 폴더 안의 줄. */
export const AdditionalDocBadge = ({ filled = false, title, onClick }) => (
  <Tooltip title={title || ''} disableHoverListener={!title}>
    <Box
      component="span"
      onMouseDown={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
        onClick?.(e);
      }}
      sx={{
        flexShrink: 0,
        px: 0.5,
        borderRadius: 0.5,
        fontSize: 10,
        lineHeight: 1.6,
        letterSpacing: '-0.02em',
        color: filled ? '#fff' : BADGE_COLOR,
        bgcolor: filled ? BADGE_COLOR : 'transparent',
        border: '1px solid',
        borderColor: BADGE_COLOR,
        cursor: onClick ? 'pointer' : 'default',
        userSelect: 'none',
      }}
    >
      추가 서류
    </Box>
  </Tooltip>
);

const SubMatFolderIcon = ({ folder }) => {
  const mark = subMatFolderActions.folderAttributeMark(folder);
  const title = mark
    ? (folder?.currentFile ? `${mark.label} · 사용중` : mark.label)
    : (folder?.currentFile ? '사용중' : '보관');
  return (
    <Box
      component="span"
      title={title}
      sx={{
        position: 'relative',
        display: 'inline-flex',
        lineHeight: 1,
        flexShrink: 0,
      }}
    >
      <span>{subMatFolderActions.folderEmoji(folder)}</span>
      {mark && (
        <Box
          component="span"
          aria-hidden
          sx={{
            position: 'absolute',
            left: '50%',
            top: '50%',
            right: '12%',
            bottom: '2%',
            bgcolor: mark.color,
          }}
        />
      )}
    </Box>
  );
};

export default SubMatFolderIcon;
